var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { CheckboxGroup } from '../form';
export var CheckboxFilter = function (_a) {
    var filter = _a.filter, filterCriteria = _a.filterCriteria, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, maxVisible = _a.maxVisible, _c = _a.shouldShowSearchBar, shouldShowSearchBar = _c === void 0 ? false : _c, _d = _a.showShowLabel, showShowLabel = _d === void 0 ? false : _d, setFilters = _a.setFilters, filters = _a.filters;
    var handleFilterCheckboxChange = function (value, queryKey) {
        var _a;
        var options = (_a = filterCriteria.find(function (filter) { return filter.queryName === queryKey; })) === null || _a === void 0 ? void 0 : _a.options.filter(function (option) { return value.includes(option.id); });
        setFilters(function (prevFilters) { return (__assign(__assign({}, prevFilters), { appliedFilters: __spreadArray(__spreadArray([], prevFilters.appliedFilters.filter(function (filter) { return filter.queryKey !== queryKey; }), true), (options || []).map(function (option) { return ({
                queryKey: queryKey,
                label: option.name,
                value: option.id,
            }); }), true) })); });
    };
    return (_jsx(CheckboxGroup, { label: showShowLabel ? filter.filterTitle : undefined, variant: variant, labelVariant: 'description', maxVisible: maxVisible, onChange: function (values) { return handleFilterCheckboxChange(values, filter.queryName); }, value: filters.appliedFilters
            .filter(function (f) { return f.queryKey === filter.queryName; })
            .map(function (f) { return f.value; }), options: filter.options.map(function (option) { return ({
            label: option.name,
            value: option.id,
        }); }), shouldShowSearchBar: shouldShowSearchBar }));
};
